import { render, staticRenderFns } from "./PromotedBuyBox.vue?vue&type=template&id=ddb2fe64&"
import script from "./PromotedBuyBox.vue?vue&type=script&lang=ts&"
export * from "./PromotedBuyBox.vue?vue&type=script&lang=ts&"
import style0 from "./PromotedBuyBox.vue?vue&type=style&index=0&id=ddb2fe64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports